// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__WNJ1y","sendOtp":"AuthorizeToLogin_sendOtp__231xo"};